module.exports = __webpack_public_path__ + "static/media/curs2.441e878b.svg";